import { useTheme } from '../context/ThemeContext';
import './AboutPage.css';

const AboutPage = () => {
  const { theme } = useTheme();

  return (
    <div
      className="about-page"
      data-theme={theme}
      style={{ maxWidth: "700px", margin: "0 auto" }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "0.5rem", fontSize: "2rem", fontWeight: "700" }}>
        About EBI Education
      </h1>
      <p style={{ textAlign: "center", color: "var(--text-secondary-light)", marginBottom: "2.5rem" }}>
        Where excellence in teaching meets passion for learning
      </p>

      <div
        style={{
          border: "1px solid var(--border-light)",
          borderRadius: "12px",
          padding: "2rem",
          marginBottom: "2rem",
          background: "var(--bg-light)",
        }}
      >
        <h2 style={{ marginBottom: "0.25rem", fontSize: "1.5rem" }}>Sanjay Singh</h2>
        <p style={{ color: "var(--text-secondary-light)", fontWeight: "600", marginBottom: "1rem" }}>
          Founder & Principal Educator
        </p>
        <p style={{ lineHeight: "1.8", marginBottom: "1rem" }}>
          With over 15 years of teaching experience, Sanjay Sir specializes in Mathematics and Physics
          for senior classes. His unique teaching methodology has helped hundreds of students achieve
          academic excellence and secure top ranks in competitive examinations.
        </p>
        <div>
          <strong>Specializations:</strong>
          <ul style={{ marginTop: "0.5rem", lineHeight: "2" }}>
            <li>Class 11–12 Mathematics</li>
            <li>JEE / NEET Foundation</li>
            <li>Problem Solving Techniques</li>
            <li>Competitive Exam Strategies</li>
          </ul>
        </div>
      </div>

      <div
        style={{
          border: "1px solid var(--border-light)",
          borderRadius: "12px",
          padding: "2rem",
          background: "var(--bg-light)",
        }}
      >
        <h2 style={{ marginBottom: "0.75rem", fontSize: "1.25rem" }}>Our Mission</h2>
        <p style={{ lineHeight: "1.8" }}>
          At EBI Education, we believe in nurturing each student's potential through personalized
          attention, innovative teaching methods, and a curriculum designed to challenge and inspire.
        </p>
      </div>
    </div>
  );
};

export default AboutPage;

/*
===== ORIGINAL ABOUT PAGE CODE (commented out) =====

import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import './AboutPage.css';
import img1 from '../assets/img1.jpg';
import img2 from '../assets/img2.jpg';
import img3 from '../assets/img3.jpg';
import img4 from '../assets/img4.jpg';
import sanjay from '../assets/sanjay.jpg';
import Tanya from '../assets/Tanya.jpg';
// Import faculty photos
import manpreet from '../assets/manpreet.jpg';
import mam from '../assets/mam.jpg';
import commerceTeacher from '../assets/commerce.jpg'; // Add this image

const AboutPage = () => {
  const { theme } = useTheme();
  const [expandedFaculty, setExpandedFaculty] = useState(null);
  const [sanjayExpanded, setSanjayExpanded] = useState(false);

  const toggleFaculty = (index) => {
    if (expandedFaculty === index) {
      setExpandedFaculty(null);
    } else {
      setExpandedFaculty(index);
    }
  };

  const toggleSanjay = () => {
    setSanjayExpanded(!sanjayExpanded);
  };

  return (
    <div className="about-page" data-theme={theme}>
      {/* Header Section *\/}
      <section className="about-header">
        <h1 className="gradient-text">About EBI Education</h1>
        <p className="tagline">Where excellence in teaching meets passion for learning</p>
      </section>

      {/* Main Teacher Section *\/}
      <section className="main-teacher" onClick={toggleSanjay}>
        <div className="teacher-profile">
          <div className="teacher-info">
            <h2>Sanjay Singh</h2>
            <p className="title">Founder & Principal Educator</p>
            <p className="bio">
              With over 15 years of teaching experience, Sanjay Sir specializes in Mathematics and Physics for senior classes.
              His unique teaching methodology has helped hundreds of students achieve academic excellence and secure top ranks
              in competitive examinations.
            </p>
            <div className={`specialization ${sanjayExpanded ? 'expanded' : 'mobile-hidden'}`}>
              <h3>Specializations:</h3>
              <ul>
                <li>Class 11-12 Mathematics</li>
                <li>JEE/NEET Foundation</li>
                <li>Problem Solving Techniques</li>
                <li>Competitive Exam Strategies</li>
              </ul>
            </div>
          </div>
          <div className="teacher-photo">
            <div className="photo-placeholder">
              <img src={sanjay} alt="Sanjay Singh - Founder of EBI Education" />
            </div>
          </div>
        </div>
      </section>

      {/* Other Teachers Section *\/}
      <section className="other-teachers">
        <h2>Our Expert Faculty</h2>

        <div className="teacher-cards">
          {/* Teacher 1 *\/}
          <div
            className={`teacher-card ${expandedFaculty === 0 ? 'expanded' : ''}`}
            onClick={() => toggleFaculty(0)}
          >
            <div className="teacher-photo-small">
              <div className="faculty-photo">
                <img src={manpreet} alt="Manpreet Sir - Foundation courses" />
              </div>
            </div>
            <h3>Manpreet Sir</h3>
            <p className="subject">Foundation courses</p>
            <div className="teacher-details">
              <p className="teacher-bio">
                5 years experience teaching foundation subjects to class 10-12 students.
                Focuses on conceptual clarity and practical applications.
              </p>
              <div className="teacher-specs">
                <p><strong>Classes:</strong> 9-12</p>
                <p><strong>Approach:</strong> Demonstration-based learning</p>
              </div>
            </div>
          </div>

          {/* Teacher 2 *\/}
          <div
            className={`teacher-card ${expandedFaculty === 1 ? 'expanded' : ''}`}
            onClick={() => toggleFaculty(1)}
          >
            <div className="teacher-photo-small">
              <div className="faculty-photo t1">
                <img src={Tanya} alt="Tanya Mam - Chemistry Mentor" className='t2' />
              </div>
            </div>
            <h3>Tanya Mam</h3>
            <p className="subject">Chemistry Mentor</p>
            <div className="teacher-details">
              <p className="teacher-bio">
                Specializes in making complex Chemistry concepts accessible through real-world examples
                and interactive experiments.
              </p>
              <div className="teacher-specs">
                <p><strong>Classes:</strong> 10-12</p>
                <p><strong>Approach:</strong> Experimental learning</p>
              </div>
            </div>
          </div>

          {/* Teacher 3 *\/}
          <div
            className={`teacher-card ${expandedFaculty === 2 ? 'expanded' : ''}`}
            onClick={() => toggleFaculty(2)}
          >
            <div className="teacher-photo-small">
              <div className="faculty-photo">
                <img src={mam} alt="Suman Mam - Biology Mentor" />
              </div>
            </div>
            <h3>Suman Mam</h3>
            <p className="subject">Biology Mentor</p>
            <div className="teacher-details">
              <p className="teacher-bio">
                Guides students in biology while building critical thinking skills
                Helps students explore biology and develop analytical skills.
              </p>
              <div className="teacher-specs">
                <p><strong>Classes:</strong> 11-12</p>
                <p><strong>Approach:</strong> Interactive discussions</p>
              </div>
            </div>
          </div>

          {/* New Commerce Teacher *\/}
          <div
            className={`teacher-card ${expandedFaculty === 3 ? 'expanded' : ''}`}
            onClick={() => toggleFaculty(3)}
          >
            <div className="teacher-photo-small">
              <div className="faculty-photo">
                <img src={commerceTeacher} alt="Commerce Teacher" />
              </div>
            </div>
            <h3>Shallu Mam</h3>
            <p className="subject">Commerce Mentor</p>
            <div className="teacher-details">
              <p className="teacher-bio">
                Expert in Accountancy, Business Studies, and Economics with 8 years of teaching experience.
                Focuses on practical application of commerce concepts and exam preparation.
              </p>
              <div className="teacher-specs">
                <p><strong>Classes:</strong> 11-12</p>
                <p><strong>Approach:</strong> Case-study based learning</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Photo Gallery Section *\/}
      <section className="photo-gallery">
        <h2>Glimpses of EBI</h2>
        <div className="gallery-grid">
          <div className="gallery-item">
            <img src={img1} alt="EBI Classroom" />
          </div>
          <div className="gallery-item">
            <img src={img2} alt="EBI Teaching Session" />
          </div>
          <div className="gallery-item">
            <img src={img3} alt="EBI Students" />
          </div>
          <div className="gallery-item">
            <img src={img4} alt="EBI Learning Environment" />
          </div>
        </div>
        <p className="gallery-note">Our classroom environment and teaching sessions</p>
      </section>

      {/* Mission Statement *\/}
      <section className="mission-statement">
        <h2>Our Mission</h2>
        <p>
          At EBI Education, we believe in nurturing each student's potential through personalized attention,
          innovative teaching methods, and a curriculum designed to challenge and inspire.
        </p>
      </section>
    </div>
  );
};

export default AboutPage;
*/
